export interface IOrganizationOrderSource {
  order_source_type: string;
  order_source_display: string;
  digits: number;
  available: boolean;
  alphaNumeric: boolean;
  use_customer_phone: boolean;
  use_customer_name: boolean;
  manual_code_entry: boolean;
  preferred_order: string;
}

export type OrganizationOrderSourcePayload = {
  order_source_type: string;
  order_source_display: string;
  digits: number;
  available: boolean;
  alphaNumeric: boolean;
  use_customer_phone: boolean;
  use_customer_name: boolean;
  manual_code_entry: boolean;
  preferred_order: string;
}

export class OrganizationOrderSource implements IOrganizationOrderSource {
  public order_source_type = '';
  public order_source_display = '';
  public digits = 3;
  public available = true;
  public alphaNumeric = false;
  public use_customer_phone = false;
  public use_customer_name = false;
  public manual_code_entry = true;
  public preferred_order = '';

  public constructor(args: IOrganizationOrderSource) {
    this.order_source_type = args.order_source_type;
    this.order_source_display = args.order_source_display;
    this.digits = args.digits;
    this.available = args.available;
    this.alphaNumeric = args.alphaNumeric;
    this.use_customer_name = args.use_customer_name;
    this.use_customer_phone = args.use_customer_phone;
    this.manual_code_entry = args.manual_code_entry;
    this.preferred_order = args.preferred_order;
  }

  public static create(args: IOrganizationOrderSource): OrganizationOrderSource {
    return new this(args);
  }

  public static payload(args: OrganizationOrderSource): OrganizationOrderSourcePayload {
    const p = Object.assign({}, {
      order_source_type: args.order_source_type,
      order_source_display: args.order_source_display,
      digits: args.digits,
      available: args.available,
      alphaNumeric: args.alphaNumeric,
      use_customer_name: args.use_customer_name,
      use_customer_phone: args.use_customer_phone,
      manual_code_entry: args.manual_code_entry,
      preferred_order: args.preferred_order,
    });
    return p;
  }
}
